export const LV2_PATHS = {
  ACTIONS: 'actions',
  COMMUNITIES: 'territoire/collectivites',
  AGENTS: 'territoire/agents',
  SITES: 'territoire/sites',
  FOLDERS: 'dossiers',
  SPENDINGS: 'depenses',
  PAYMENTS: 'versements',
  HOME: 'home',
  PROFILE: 'profile',
  SETTINGS: 'settings',
  LOGIN: 'login',
  LOGIN_PROCONNECT: 'login/proconnect',
  LOGIN_FORM: 'login/form',
  LOGIN_NO_PROVIDER: 'login/no-provider',
  REGISTER: 'register',
  REGISTER_CHECK_EMAIL: 'register/check-email',
  VERIFY_EMAIL: 'verify-email',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  ACCOUNT_STATUS: 'account-status',
  CREATE: 'create',
  NOT_FOUND: 'not-found',
} as const;

export type Lv2Path = (typeof LV2_PATHS)[keyof typeof LV2_PATHS];

export const UrlParams = {
  USER_FRIENDLY_ID: 'userFriendlyId',
};

const DOC_URL = 'https://docs.programme-cee-actee.fr/';
const USER_ACCOUNT_URL = `${DOC_URL}general/compte-utilisateur`;
const LEARN_MORE_ACTIONS_URL = `${DOC_URL}details/actions`;
const LEARN_MORE_AGENTS_URL = `${DOC_URL}details/agents`;
const LEARN_MORE_SITE_URL = `${DOC_URL}details/sites-et-batiments`;
const LEARN_MORE_FOLDER_URL = `${DOC_URL}details/dossiers`;
const LEARN_MORE_COMMUNITIES_URL = `${DOC_URL}details/collectivites`;
const IPPER_URL =
  'https://programme-cee-actee.fr/actualites/ipper-inventaire-du-patrimoine-public-et-des-consommations-denergie/';
const APP_IPPER_URL = 'https://app.ipper.fr/';
const PROCONNECT_INFO_URL = 'https://www.proconnect.gouv.fr/';

export const EXTERNAL_LINKS = {
  GITBOOK: DOC_URL,
  USESRS_GITBOOK: USER_ACCOUNT_URL,
  ACTIONS_GITBOOK: LEARN_MORE_ACTIONS_URL,
  AGENTS_GITBOOK: LEARN_MORE_AGENTS_URL,
  SITES_GITBOOK: LEARN_MORE_SITE_URL,
  FOLDERS_GITBOOK: LEARN_MORE_FOLDER_URL,
  COMMUNITIES_GITBOOK: LEARN_MORE_COMMUNITIES_URL,
  IPPER_DOC: IPPER_URL,
  APP_IPPER: APP_IPPER_URL,
  PROCONNECT_INFO: PROCONNECT_INFO_URL,
} as const;

export const DEFAULT_PATH = LV2_PATHS.HOME;
